module.exports = __webpack_public_path__ + "static/media/sketches.650050c7.jpeg";